module.exports = __webpack_public_path__ + "img/close.9464168f.svg";